import { ReactNode } from 'react';
import Suspense from '../suspense/Suspense';
import ErrorBoundary from '../../atom/error-boundary/ErrorBoundary';

interface ErrorSuspenseProps {
  /**
   * react node
   */
  children?: ReactNode;
}

const ErrorSuspense = (props: ErrorSuspenseProps) => {
  /**
   * 소품
   */
  const { children } = props;

  return (
    <Suspense>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Suspense>
  );
};

export default ErrorSuspense;
